import api from 'api'

export interface WorkItemInReview {
  companyId: number
  companyName?: string | null
  shiftId: number
  workerId: number
  workerName?: string | null
  workId: number
  status: string
}

export async function getW2WorkItemsInReview(): Promise<WorkItemInReview[]> {
  const resp = await api.get('/admin/w2/work_items_in_review')
  return resp.data as WorkItemInReview[]
}
